interface StatusTextProps {
  status: string;
  className?: string;
}

export const StatusText = ({ status, className = '' }: StatusTextProps) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'canceled':
        return 'font-semibold text-red text-xs uppercase leading-3';
      case 'postponed':
        return 'text-orange text-xs uppercase leading-3';
      case 'running':
        return 'font-semibold text-light-blue text-xs leading-3';
      default:
        return 'text-xs leading-3';
    }
  };

  const getStatusText = () => {
    return status === 'running' ? 'Live' : status;
  };

  return (
    <p className={`${getStatusStyles()} ${className}`}>{getStatusText()}</p>
  );
};
